module.exports = __webpack_public_path__ + "img/2416666.e6c6984d.png";